import { 
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT, 
    TURTLE_CROSSING_PIN,
    SOCKS,  
    Product
} from '../products';

const startSeeingTurtlesRecos: Product[] = [
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    TURTLE_CROSSING_PIN,
    SOCKS,   
];

export default startSeeingTurtlesRecos;